import ContactCard from '../components/ContactCard'
import axios from 'axios'
import qs from 'qs'

// Init Page
const findContactFrame = document.getElementById('findContact')

if (findContactFrame) {
  document.addEventListener('DOMContentLoaded', () => {
    if (findContactFrame) {
      const elem = document.querySelector('.contact-card-frame')
      findContactFrame.addEventListener('submit', (e) => {
        // we ajax
        e.preventDefault()
        // remove all cards

        if (document.querySelectorAll('.contact-card').length > 0) {
          document
            .querySelectorAll('.contact-card')
            .forEach((ansprechpartner) => ansprechpartner.remove())
        }

        const target = e.target as EventTarget & HTMLFormElement

        const actionURL = target.action
        // getting form data
        const data = new FormData(target)
        // preparing data - also setting ajax to true - if not we reject it in ContactController.php
        // prettier-ignore
        const formData = { 'tx_ytdcg_contact': { ajax: true, plz: data.get('tx_ytdcg_contact[plz]') } }

        axios
          .post(actionURL, qs.stringify(formData))
          .then((response) => {
            elem!.innerHTML = ''
            // Making Card Elements from response
            if (response.data.error) {
              // if error
              const error = document.createElement('div')
              error.classList.add('error')
              error.innerHTML = response.data.error
              elem?.appendChild(error)
            } else {
              response.data.forEach((x: any) => {
                if (elem) {
                  elem.append(
                    new ContactCard(
                      x.name,
                      x.photo,
                      x.occupation,
                      x.position,
                      x.place,
                      x.mobile,
                      x.phone,
                      x.email
                    )
                  )
                }
              })
            }
          })
          .catch((error) => console.log(error))
          .finally(() => {
            // 50ms per element + 500ms from animation
            document
              .querySelectorAll('.contact-card')
              .forEach((card, index) => {
                setTimeout(() => {
                  card.classList.toggle('show')
                }, 50 * index + 650)
              })
          })
      })
    }
  })
}

// Animation
if (document.getElementById('cardframe')) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.contact-card').forEach((contact, index) => {
      setTimeout(() => {
        contact.classList.toggle('show')
      }, 50 * index)
    })
  })
}
